export class BaseEvent {
    constructor(type) {
        this.type = type;
    }
}
export class GraphLifeCycleEvent extends BaseEvent {
    constructor(type, data) {
        super(type);
        this.data = data;
    }
}
export class AnimateEvent extends BaseEvent {
    constructor(type, animationType, animation, data) {
        super(type);
        this.animationType = animationType;
        this.animation = animation;
        this.data = data;
    }
}
export class ElementLifeCycleEvent extends BaseEvent {
    constructor(type, elementType, data) {
        super(type);
        this.elementType = elementType;
        this.data = data;
    }
}
export class ViewportEvent extends BaseEvent {
    constructor(type, data) {
        super(type);
        this.data = data;
    }
}
//# sourceMappingURL=events.js.map